import { render, staticRenderFns } from "./form-component-select-from-overview.vue?vue&type=template&id=455240b8&scoped=true"
import script from "./form-component-select-from-overview.vue?vue&type=script&lang=ts"
export * from "./form-component-select-from-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455240b8",
  null
  
)

export default component.exports